module.exports = __webpack_public_path__ + "school/img/duomeiBg.29eeb30d.jpg";